module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ec6a73c85e83c5db5a1db7134eca25ec.png";